const conversionFactors = {
  Ohms: 1,
  Kilohms: 1e3,
  Megohms: 1e6,
  Gigaohms: 1e9,
  Milliohms: 1e-3,
  Microohms: 1e-6,
  Nanoohms: 1e-9,
  Abohms: 1e-9,  // 1 abohm = 10^-9 ohms
  Statohms: 8.987551787e11  // 1 statohm ≈ 8.987551787 × 10^11 ohms
};

export const convertResistance = (value, fromUnit, toUnit) => {
  const valueInOhms = value * conversionFactors[fromUnit];
  return valueInOhms / conversionFactors[toUnit];
};
